import React from "react"

const Phone = props => (
  <li className="Device">
    <a href={"/Shop" + "/" + props.manufacture + "/" + props.modelname}>
      {props.banner}
      <div className="Device-Contents">
        <img
          className="Device-Product"
          src={props.product}
          id={props.id}
          alt={props.phone}
        />
        <a href={"/Shop" + "/" + props.manufacture + "/" + props.modelname}>
          <h4>
            {props.manufacture} {props.model}
          </h4>
        </a>
        <div className="Memory">
          <div className="Storage">
            {props.storage1}
            -
            {props.storage2}
          </div>
        </div>
        <div className="Color-Grid">
          {props.color1}
          {props.color2}
          {props.color3}
          {props.color4}
          {props.color5}
          {props.color6}
        </div>
        <div className="Memory">
          <strong className="Available">Available from</strong>
          <strong class="Price">£{props.price}</strong>
        </div>
        <div className="Buttons">
          <a className="Device-Button" href="/shop">
            + Compare
          </a>
        </div>
      </div>
    </a>
  </li>
)

export default Phone
